/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
	If that file is not included, it is redefined here.
==============================================================================*/
if (typeof Shopify === "undefined") {
  Shopify = {};
}
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = "",
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || this.money_format;

    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}
$(document).ready(function (){
  var $window = $(window),
    currentTotal = 0,
    currentStep = 1,
    maxProductsNumber = 0,
    inBundleProducts = {products: {}, count: 0};

  /* Close pop-up button event */
  $(document).on('click', '.close-popup-btn', function(e) {
    e.preventDefault();
    $(this).closest('.animatedModal').fadeOut(300);
  });

  /* Custom select events */
        $(document).on('click', '.custom-select-btn', function(e){
            var $thisSelect = $(this).closest('.custom-select');
            $('.custom-select.opened').not($thisSelect).removeClass('opened');
            $thisSelect.toggleClass('opened');
        });
      $(document).on('change', '.custom-select input', function(e){
            var $thisSelect = $(this).closest('.custom-select');
            var $thisOptionWrap = $(this).closest('.custom-select-option');
            var inputText = $('label', $thisOptionWrap).html();
            $('.custom-select-btn-text', $thisSelect).html(inputText);
            $thisSelect.removeClass('opened');
        });

        $(document).on('click', function (e) {
            if (!$('.custom-select.opened').length){
                return;
            }
            if (!$(e.target).hasClass('custom-select') && !$(e.target).closest('.custom-select').length ){
                $('.custom-select.opened').removeClass('opened');
            }
        });
  $(document).on('click', '.main-products-grid-item-inner', function (){
    if ($('.build-bundle-page').hasClass('block-events')) {
      return;
    };
    $('.build-bundle-page').addClass('block-events');
    var $thisContainer = $(this).closest('.main-products-grid-item');
    var variantUrlName = $thisContainer.attr('data-variant-url-name');
    var bundleHandle = $thisContainer.attr('data-bundle-handle');

    var baseUrl = window.location.origin + '/products/' + bundleHandle;
    var currentUrl = window.location.href;

    if (currentUrl.startsWith(baseUrl) || currentUrl.startsWith(baseUrl + '/')) {
      var newUrl = baseUrl + '/' + variantUrlName;
      window.history.replaceState(null, '', newUrl);
    }

    if ($thisContainer.hasClass('main-product-selected') || $thisContainer.attr('data-dynamic-steps') !== 'true') {
      maxProductsNumber = +$('.bundle-products-main').attr('data-products-count');
      goToStep(currentStep + 1);
    }
    else {
      var variantId = $thisContainer.attr('data-bundle-variant-id');
      var productHandle = $thisContainer.attr('data-bundle-handle');
      inBundleProducts = {products: {}, count: 0};
      $.ajax({
        url: "/products/" + productHandle + "?variant="+variantId+"&section_id=ajax-build-bundle-steps",
        type: 'GET',
        dataType: 'html',
        success: function(data) {
          var $content = $($(data).html());
          $('.step-container-dynamic').remove();
          $content.insertAfter($('.step-container-main'));
          maxProductsNumber = +$('.bundle-products-main').attr('data-products-count');
          $('.main-product-selected').removeClass('main-product-selected');
          $thisContainer.addClass('main-product-selected');
          goToStep(currentStep + 1);
        }
      });
    }
  });

  checkUrl();

  $(document).on('click', '.add-to-bundle-btn', function(e){
    e.preventDefault();
    var $mainContainer = $(this).closest('.bundle-products');
    if ($mainContainer.attr('data-products-count') && inBundleProducts.count + 1 > maxProductsNumber) {
      return;
    }
    var $thisContainer = $(this).closest('.bundle-product');
    var variantId = $thisContainer.attr('data-variant-id');
    if($(this).hasClass('gift-product')){
      $('.gift-product').closest('.bundle-product').removeClass('bundle-product-selected');
    }
    $thisContainer.addClass('bundle-product-selected');
    if ($mainContainer.attr('data-products-count')) {
      inBundleProducts.products[variantId] = 1;
    }
    updateCurrentStepProgress();
  });
  $(document).on('click', '.bundle-product .custom-ratio-image-wrapper', function(e){
    var $thisContainer = $(this).closest('.bundle-product');
    if ($thisContainer.hasClass('bundle-product-selected')){
      $('.qnt-num', $thisContainer).val(0).trigger('change');
    }
    else {
      $('.add-to-bundle-btn', $thisContainer).trigger('click');
    }
  });

  $(document).on('click','.qnt-adjust', function (e) {
    e.preventDefault();
    var $inputQnt = $(this).siblings('.qnt-num');
    var $thisContainer = $inputQnt.closest('.bundle-product');
    var $mainContainer = $inputQnt.closest('.bundle-products');
    var qnt = +$inputQnt.val();
    var qntMax = $inputQnt.attr('max') ? +$inputQnt.attr('max') : false;
    var qntMin = $inputQnt.attr('min') ? +$inputQnt.attr('min') : 0;
    var newVal = qnt;

    if ($(this).hasClass('qnt-adjust-plus')) {
      if (qntMax && qntMax != undefined && qnt + 1 > qntMax) {
        return;
      }
      else if ($mainContainer.attr('data-products-count') && inBundleProducts.count + 1 > maxProductsNumber){
        return;
      }
      else {
        newVal = qnt + 1;
      }
    }
    else {
      if (qnt < qntMin) {
        newVal = qntMin;
      } else {
        newVal = qnt - 1;
      }
    }
    $inputQnt.val(newVal);
    $inputQnt.trigger('change');
  });

  $(document).on('change input', '.qnt-num', function(e){
    var $inputQnt = $(this);
    var $thisContainer = $inputQnt.closest('.bundle-product');
    var $mainContainer = $inputQnt.closest('.bundle-products');
    var variantId = $thisContainer.attr('data-variant-id');
    var qnt = +$inputQnt.val();
    var qntMax = $inputQnt.attr('max') ? +$inputQnt.attr('max') : false;
    var qntMin = $inputQnt.attr('min') ? +$inputQnt.attr('min') : 0;
    var newVal = qnt;
    var $minusBtn = $inputQnt.closest('.qnt-input-wrapper').find('.qnt-adjust-minus');
    $minusBtn.removeClass('qnt-adjust-disabled');
    if ($mainContainer.attr('data-products-count')){
      var maxForBundle = maxProductsNumber - (inBundleProducts.count - inBundleProducts.products[variantId]);
      maxForBundle = Math.max(maxForBundle, 0);
      qntMax = qntMax && qntMax != undefined ? Math.min(qntMax, maxForBundle) : maxForBundle;
    }

    if (e.type === 'input') {
      if ((qntMax && qntMax != undefined || qntMax === 0) && qnt > qntMax) {
        newVal = qntMax;
        $inputQnt.val(newVal);
        $inputQnt.trigger('change');
      }
      else if (qnt <= qntMin){
        newVal = qntMin;
        $inputQnt.val(newVal);
        $inputQnt.trigger('change');
      }
    }

    if ($inputQnt.attr('min') != undefined && +$inputQnt.val() === +$inputQnt.attr('min')){
      $minusBtn.addClass('qnt-adjust-disabled');
    }
    else if (!$inputQnt.attr('min') && +$inputQnt.val() <= 1){
      $minusBtn.addClass('qnt-adjust-disabled');
    }
    else {
      $minusBtn.removeClass('qnt-adjust-disabled');
    }

    if (newVal === 0){
      $thisContainer.removeClass('bundle-product-selected');
      $(this).val(1).trigger('change');
      delete inBundleProducts.products[variantId];
    }
    else if ($thisContainer.hasClass('bundle-product-selected') && $mainContainer.attr('data-products-count')){
      inBundleProducts.products[variantId] = newVal;
    }
    updateCurrentStepProgress();
  });

  $(document).on('keypress', '.qnt-num', function(e) {
    var chr = String.fromCharCode(e.which);
    if ("1234567890".indexOf(chr) < 0) {
      return false;
    }
  });

  $(document).on('click', '.bundle-filter', function (){
    $(this).toggleClass('filter-active');
    filterProducts();
  });

  $(document).on('click', '.remove-filter', function (){
    $(this).closest('.bundle-filter-wrapper').find('.bundle-filter').trigger('click');
  });

  $(document).on('input', '.bundle-search-input', function (){
    searchProducts($(this).val().toLowerCase().trim());
  });

  $(document).on('click', '.added-products-header', function (){
    $(this).toggleClass('opened');
    $(this).closest('.added-products').find('.added-products-list').slideToggle();
  });

  $(document).on('click', '.added-products-grid-item .remove-from-bundle', function (){
    var $thisContainer = $(this).closest('.added-products-grid-item');
    var variantId = $thisContainer.attr('data-variant-id');
    var $relatedProductContainer = $('.bundle-product[data-variant-id="'+variantId+'"]');
    var $inputQnt = $('.qnt-num', $relatedProductContainer);
    var currentQnt = +$inputQnt.val();
    $inputQnt.val(currentQnt - 1).trigger('change');
  });

  $(document).on('click', '.more-info-link', function (){
    var $thisContainer = $(this).closest('.bundle-products-grid-item');
    var productHandle = $thisContainer.attr('data-product-handle');
    var productTitle = $thisContainer.attr('data-product-title');
    var variantId = $thisContainer.attr('data-variant-id');
    $.ajax({
      url: "/products/" + productHandle + (variantId ? "?variant="+variantId+"&section_id=ajax-product-info" : "?section_id=ajax-product-info"),
      type: 'GET',
      dataType: 'html',
      success: function(data) {
        var $content = $(data);
        $('.product-info-popup .popup-title').text(productTitle);
        $('.product-info-popup .popup-content').html($content.html());
        $('.product-info-popup').fadeIn(300, function (){
          $(document).trigger('dynamicTastesBlockLoaded');
        });
        $('.product-info-description a', $('.product-info-popup')).attr('target', '_blank');
      }
    });
  });

  $(document).on('click', '.progress-status', function (){
    if ($(this).hasClass('progress-status-disabled')) {
      return;
    }
    if ($('.build-bundle-page').hasClass('block-events')) {
      return;
    };
    $('.build-bundle-page').addClass('block-events');
    goToStep(currentStep + 1);
  });

  $(document).on('click', '.bundle-chosen-products .added-products-grid-item:not(.product-added) .grid-added-product-inner', function (){
    goToStep(currentStep - 1);
  });

  $(document).on('change', '.bundle-product-select input', function (e){
    updateTotalPrice();
  });

  $(document).on('change', '.bundle-product .product-single__variants', function (e){
    var $priceEl = $(this).closest('.bundle-product').find('.product-price');
    var price = +$(this).find('option:selected').attr('data-price');
    $priceEl.text(theme.Currency?.formatMoneyDisplay ? theme.Currency.formatMoneyDisplay(price) : Shopify.formatMoney(price, theme.shopSettings.moneyFormat));
    updateTotalPrice();
  });

  $(document).on('click', '.build-bundle-step-completed:not(.build-bundle-step-current)', function (e){
    e.preventDefault();
    var step = +$(this).attr('data-step');
    goToStep(step);
  });
  $(document).on('click', '.back-to-prev-step', function (e){
    e.preventDefault();
    goToStep(currentStep - 1);
  });

  $(document).on('click', '.add-bundle-to-cart', function (){
    if ($(this).hasClass('add-bundle-disabled')) {
      return;
    }
    var $selectedVariants = $('.bundle-product-selected .product-single__variants option:selected, .bundle-product-select input:checked').not('[value="no"]');
    var $bundleSelected = $('.main-product-selected');
    var bundleTitle = $bundleSelected.attr('data-bundle-title');
    var bundleId = $bundleSelected.attr('data-bundle-variant-id');
    var bundleHandle = $bundleSelected.attr('data-bundle-handle');
    var bundleImage = $bundleSelected.attr('data-bundle-image');
    var bundleVariantTitle = $bundleSelected.attr('data-bundle-variant-title');
    var uniqId = + new Date();
    let componentReference = [];
    let componentQuantities = [];
    let componentPrice = [];
    $selectedVariants.each(function (){
      var variantId = +$(this).val();
      var qnt = +$(this).closest('.bundle-product').find('.qnt-num').val();
      var price = +$(this).closest('.bundle-product').find('option:selected').attr('data-price');
      componentReference.push('gid://shopify/ProductVariant/' + variantId);
      componentQuantities.push(qnt);
      componentPrice.push((Shopify.formatMoney(price, theme.shopSettings.moneyFormat)).replace(',', '.').replace(/[^\d.-]/g, ''));
    });
    let productObj = {
      id: bundleId,
      quantity: 1,
      properties: {
        _component_reference: JSON.stringify(componentReference),
        _component_quantities: JSON.stringify(componentQuantities),
        _price_adjustment: JSON.stringify(componentPrice),
        _bundlePrice: currentTotal
      }
    }
    $('.rebuy-cart').hide();
    $('.building-bundle-overlay').fadeIn(200);
    $('.build-bundle-page').addClass('block-events');
    addBundleToCart(productObj);
  });

  $window.on('scroll', function () {
    changeButtonClass();
  });

  $window.on('resize', function () {
    changeButtonClass();
  });

  function addBundleToCart(productAddToCart) {
    $('.building-progress-overlay').css({'transform': 'translateY(-100%)'});
    var timeStart = Date.now();
    $.ajax({
      type:     'POST',
      url:      theme.routes.cart_add_url + '.js',
      data:     productAddToCart,
      dataType: 'json',
      success:  function (data) {
        var timeEnd = Date.now();
        var duration = timeEnd - timeStart;
        var timeOut = duration >= 2000 ? 0 : 2000 - duration;
        setTimeout(function (){
          $('.building-status .loading-icon').hide();
          $('.building-status .complete-icon').show();
          document.location.href = $('.build-bundle-steps').attr('data-redirect-path') || '/checkout';
        }, timeOut);
      },
      error:    function (XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
        $('.building-bundle-overlay').fadeOut(100);
        $('.building-status .loading-icon').show();
        $('.building-status .complete-icon').hide();
        $('.building-progress-overlay').removeClass('building-complete').css({'transform': 'translateY(0%)'});
      }
    });
  }

  function filterProducts(){
    var $filtersSelected = $('.filter-active');
    var $allProducts = $('.bundle-products-main .bundle-product');
    var $productsToFilter = $('.bundle-products-main .filtered-by-search').length ? $('.bundle-products-main .filtered-by-search') : $allProducts;
    if (!$filtersSelected.length) {
      $allProducts.removeClass('filtered-by-filter');
      $productsToFilter.fadeIn();
      $('.no-results').slideUp(200);
    }
    else {
      var filtersValues = [];
      $filtersSelected.each(function(){
        filtersValues.push($(this).attr('data-filter').toLowerCase());
      });
      $allProducts.removeClass('filtered-by-filter').hide();
      $allProducts.each(function(){
        var productTags = $(this).attr('data-product-tags').toLowerCase();
        var matchedCount = 0;
        $.each(filtersValues, function(){
          if (productTags.indexOf(this) >=0){
            matchedCount++;
          }
        });
        if (matchedCount === filtersValues.length) {
          $(this).addClass('filtered-by-filter');
        }
      });
      $productsToFilter.filter('.filtered-by-filter').fadeIn();
      if (!$productsToFilter.filter('.filtered-by-filter').length){
        $('.no-results').slideDown(200);
      }
      else {
        $('.no-results').slideUp(200);
      }
    }
  }

  function searchProducts(term){
    var $allProducts = $('.bundle-products-main .bundle-product');
    var $productsToFilter = $('.bundle-products-main .filtered-by-filter').length ? $('.bundle-products-main .filtered-by-filter') : $allProducts;
    if (term.trim().length < 2) {
      $allProducts.removeClass('filtered-by-search');
      $productsToFilter.fadeIn();
      $('.no-results').slideUp(200);
    }
    else {
      // $('.no-results').slideUp(200);
      $allProducts.removeClass('filtered-by-search').hide();
      $allProducts.each(function(){
        var showProduct = false;
        var productTags = $(this).attr('data-product-tags').toLowerCase();
        var productType = $(this).attr('data-product-type').toLowerCase();
        var productTitle = $(this).attr('data-product-title').toLowerCase();
        var allProductTerms = productTags.split(',');
        allProductTerms.push(productType, productTitle);
        var termParts = term.split(' ');
        if (termParts.length > 0){
          var partsMatched = 0;
          $.each(termParts, function(){
            var termPart = this;
            $.each(allProductTerms, function(){
              if (termPart.indexOf(this) >=0 || this.indexOf(termPart) >=0){
                partsMatched++;
                return false;
              }
            });
          });
          if (partsMatched === termParts.length){
            showProduct = true;
          }
        }
        else {
          $.each(allProductTerms, function(){
            if (term.indexOf(this) >=0 || this.indexOf(term) >=0){
              showProduct = true;
              return false;
            }
          });
        }

        if (showProduct) {
          $(this).addClass('filtered-by-search');
        }
      });
      $productsToFilter.filter('.filtered-by-search').fadeIn();
      if (!$productsToFilter.filter('.filtered-by-search').length){
        $('.no-results').slideDown(200);
      }
      else {
        $('.no-results').slideUp(200);
      }
    }
  };

  function updateTotalPrice(){
    updateDefinedProducts();

    var $selectedVariants = $('.bundle-product-selected .product-single__variants option:selected, .bundle-product-select input:checked').not('[value="no"]');
    currentTotal = 0;
    $selectedVariants.each(function (){
      var qnt = +$(this).closest('.bundle-product').find('.qnt-num').val();
      currentTotal += +$(this).attr('data-price') * qnt;
    });
    $('.bundle-final-price').text(theme.Currency?.formatMoneyDisplay ? theme.Currency.formatMoneyDisplay(currentTotal) : Shopify.formatMoney(currentTotal, theme.shopSettings.moneyFormat));
  };

  function updateCurrentStepProgress() {
    var totalProductsCount = 0;
    $.each(inBundleProducts.products, function (key, value){
      totalProductsCount += value;
    });
    inBundleProducts.count = totalProductsCount;

    var $progressSectionMain = $('.bundle-progress-section-main');
    var $progressSectionFinal = $('.bundle-progress-section-final');
    var $progressBarAddedProducts = $('.added-products-grid-item', $progressSectionMain);
    var $progressBarAddedImages = $('.added-product-image', $progressBarAddedProducts);

    var lastInd = -1;
    $.each(inBundleProducts.products, function(key, val){
      if (lastInd + 1 > maxProductsNumber){
        return false;
      }
      var variantId = key;
      var $productEl = $('.bundle-product[data-variant-id="'+variantId+'"]');
      var imgSrc = $('.product-image', $productEl).prop('currentSrc');

      for (var i=0; i < val; i++){
        lastInd++;
        $progressBarAddedImages.eq(lastInd).attr('src', imgSrc);
        $progressBarAddedProducts.eq(lastInd).addClass('product-added').attr('data-variant-id', variantId);
      }
    });

    if (lastInd + 1 < maxProductsNumber){
      for (var j=maxProductsNumber - 1; j > lastInd; j--) {
        $progressBarAddedProducts.eq(j).removeClass('product-added').removeAttr('data-variant-id');
      }
      $('.progress-status').addClass('progress-status-disabled');
      $('.progress-status-completed').hide();
      $('.progress-status-uncompleted').show();
      $('.left-to-add-count').text(maxProductsNumber - lastInd - 1);
      $('.add-bundle-to-cart').addClass('add-bundle-disabled');
      $('.bundle-products-main .add-to-bundle-btn').removeAttr('disabled');
      if ($('.progress-status .product-unit').length){
        var productUnit = $('.progress-status .product-unit').attr('data-product-unit').split(',');
        $('.progress-status .product-unit').text(maxProductsNumber - lastInd - 1 > 1 ? productUnit[1] : productUnit[0]);
      }
    }
    else {
      $('.progress-status-uncompleted').hide();
      $('.progress-status-completed').show();
      $('.progress-status').removeClass('progress-status-disabled');
      $('.add-bundle-to-cart').removeClass('add-bundle-disabled');
      $('.bundle-products-main .add-to-bundle-btn').attr('disabled', true);
    }
    $('.added-count').text(lastInd + 1);
    $('.progress-bar-scale').width((100 - (lastInd + 1)/maxProductsNumber*100) + '%');

    var $clonedItems = $progressBarAddedProducts.clone();
    $('.added-products-grid', $progressSectionFinal).html('').append($clonedItems);
    updateTotalPrice();
  };

  function goToStep(nextStep) {
    if (nextStep < 1){
      if (document.referrer) {
        window.location.href = document.referrer;
      }
      else {
        window.location.href = '/';
      }
      return;
    } else if (nextStep === 1) {
      var currentUrl = window.location.href;
      var urlParts = currentUrl.split('/');
      if (urlParts.length > 1) {
        urlParts.pop();
      }

      var newUrl = urlParts.join('/');
      window.history.replaceState(null, '', newUrl);
    }
    $('.step-container-active').hide().removeClass('step-container-active');
    $('.step-container-prev').removeClass('step-container-prev');
    window.scrollTo({ top:0, left:0, behavior: "instant"})
    if (nextStep < currentStep){
      $('.step-container[data-step="' + nextStep + '"]').addClass('step-container-prev');
    }
    $('.step-container[data-step="' + nextStep + '"]').fadeIn(500, function (){
      $('.build-bundle-page').removeClass('block-events');
    }).addClass('step-container-active');

    if (nextStep > currentStep){
      $('.build-bundle-step[data-step="' + currentStep + '"]').addClass('build-bundle-step-completed')
    }
    $('.build-bundle-step[data-step="' + currentStep + '"]').removeClass('build-bundle-step-current');
    $('.build-bundle-step[data-step="' + nextStep + '"]').addClass('build-bundle-step-current').removeClass('build-bundle-step-completed');

    $('.main-products-grid-item-inner').removeClass('is-loading');
    // $('.build-bundle-page').removeClass('build-bundle-page');
    currentStep = nextStep;
    changeButtonClass();

    if ($('.step-container[data-step="1"] .step-container-overlay')) {
      $('.step-container[data-step="1"] .step-container-overlay').remove();
    }
  };
  function changeButtonClass() {
    let footerOffset = $('.shopify-section-footer').offset().top - 70;
    let windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    let btnWrapEmpty = $('.add-bundle-btn-empty');
    if ($(window).scrollTop() >= (footerOffset - windowHeight)) {
      $('.add-bundle-btn-wrapper').removeClass('fixed-btn');
      btnWrapEmpty.hide();
    } else {
      $('.add-bundle-btn-wrapper').addClass('fixed-btn');
      btnWrapEmpty.show();
    }
  }

  function checkUrl() {
    let baseUrl = window.location.pathname;
    if (baseUrl[baseUrl.length - 1] === '/') {
      baseUrl = baseUrl.slice(0, -1);
    }

    var path = baseUrl.split('/');
    var productVariant = path[path.length - 1];
    var activeBlock = $('.main-products-grid-item[data-variant-url-name="' + productVariant + '"]');

    if (activeBlock.length) {
      activeBlock.find('.main-products-grid-item-inner').trigger('click');
    } else {
      $('.step-container[data-step="1"] .step-container-overlay').remove();
    }
  }

  function updateDefinedProducts() {
    var $selectedVariantsWithoutDefined = $('.bundle-product-selected:not(.defined-bundle-product) .product-single__variants option:selected, .bundle-product-select input:checked').not('[value="no"]');
    var $definedBundleProducts = $('.defined-bundle-product');

    $selectedVariantsWithoutDefined.length === 0 ? $definedBundleProducts.removeClass('bundle-product-selected') : $definedBundleProducts.addClass('bundle-product-selected');
  }
});
